import React from 'react';
import {
  ModalScrollableContent,
  ModalScrollableHeader,
  ModalScrollableContainer,
} from '../../components/modal';
import { LawyerCommentarySelection } from '../../lawyer/page/lawyer-commentaries/LawyerCommentarySelection';
import { Commentary } from '../../commentary/commentary.types';
import { fetchCommentaries } from '../../lawyer/lawyer.api';
import { CommentariesModalLoader } from '../../components/commentaries-modal-placeholder/CommentariesModalLoader';

type Props = {
  lawyerId: string;
  onRequestClose: () => void;
  isOpen: boolean;
  source: string;
  decision: { title: string };
};

type State = {
  commentaries: Commentary[];
  totalNumber: number;
  isLoading: boolean;
};

export class AllLawyerCommentariesModal extends React.Component<Props, State> {
  static defaultProps = {
    onRequestClose: () => {},
    isOpen: false,
  };

  state: State = {
    commentaries: [],
    totalNumber: 0,
    isLoading: true,
  };

  async componentDidMount() {
    const full = true;
    const userGeneratedOnly = false;
    const { commentaries, totalNumber } = (
      await fetchCommentaries(this.props.lawyerId, full, userGeneratedOnly)
    ).data;

    this.setState({ commentaries, totalNumber, isLoading: false });
  }

  render() {
    const { commentaries, totalNumber, isLoading } = this.state;
    const { onRequestClose, isOpen } = this.props;
    return (
      <ModalScrollableContainer onRequestClose={onRequestClose} isOpen={isOpen}>
        <ModalScrollableHeader
          title={`Commentaires (${totalNumber})`}
          onClose={onRequestClose}
        />
        <ModalScrollableContent>
          <CommentariesModalLoader isLoading={isLoading}>
            {commentaries.map((commentary, index) => (
              <LawyerCommentarySelection
                key={commentary.title}
                commentary={commentary}
                index={index}
              />
            ))}
          </CommentariesModalLoader>
        </ModalScrollableContent>
      </ModalScrollableContainer>
    );
  }
}
